import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThLarge } from "@fortawesome/pro-regular-svg-icons/faThLarge";

export const defaultTranslations = {
    pluginName: "Panel Grid",
    pluginDescription: "Add a panel grid",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faThLarge} size="3x" />,
};
